import React from 'react';
import { Icon } from '../Icon/Icon';
import DSLogo from '../../../assets/icons/svg/DsLogo';
import { Paragraph, ParagraphProps } from '../Paragraph/Paragraph';

export interface LogoProps {
  className?: string;
  text?: string;
  textSize?: ParagraphProps['size'];
}

export const Logo = ({ text, textSize = 14, className }: LogoProps) => (
  <div className={`flex flex-col fill-neutrals-coolGrey-400 text-neutrals-coolGrey-400 ${className}`}>
    <Icon
      icon={<DSLogo />}
      className='stroke-none'
    />

    {text && (
      <Paragraph
        italic={true}
        size={textSize}
        weight='bold'
        className='pt-8'
      >
        {text}
      </Paragraph>
    )}
  </div>
);

